module.exports = __webpack_public_path__ + "static/media/background.7adc33b0.webp";